export default {
  nav: {
    overview: "Обзор",
    applications: "Заявки",
    members: "Реестр",
    authors: "Кабинет автора",
    works: "Верификация",
    events: "Мероприятия",
    structure: "Структура",
  },
  overviewTitle: "Рабочее место Союза писателей",
  overviewHint: "Модерация заявок, реестр членов и верификация произведений.",
  applicationsEmpty: "Нет заявок на рассмотрении.",
  membersEmpty: "Реестр пуст.",
  worksEmpty: "Нет произведений на проверке.",
  approve: "Принять",
  reject: "Отклонить",
  verify: "Подтвердить",
  overview: {
    welcomeHint: "Заявки на вступление, реестр членов и проверка авторства произведений.",
    statsTitle: "Сводка",
    applicationsTitle: "Заявки",
    applicationsHint: "Кандидаты ждут решения Союза.",
    worksTitle: "Верификация",
    worksHint: "Произведения ждут подтверждения авторства.",
    membersTitle: "Реестр членов",
    membersHint: "Действующие члены Союза писателей.",
    pending: "Ждут решения",
    total: "Всего",
    servicesTitle: "Быстрые действия",
    services: {
      applications: { title: "Заявки", desc: "Принять или отклонить кандидатов." },
      members: { title: "Реестр", desc: "Члены Союза, номера билетов и годы вступления." },
      authors: { title: "Кабинет автора", desc: "Завести профиль и выдать ссылку для входа." },
      works: { title: "Верификация", desc: "Подтвердить авторство произведений." },
    },
  },
  applications: {
    subtitle: "Кандидаты, подавшие заявку на вступление в Союз.",
    columns: { name: "Кандидат", region: "Регион", submitted: "Подана", actions: "Решение" },
    approveTitle: "Принять в Союз",
    approveMessage: "{{name}} станет членом Союза писателей.",
    rejectTitle: "Отклонить заявку",
    rejectMessage: "Кандидат {{name}} увидит отказ и комментарий в кабинете.",
    note: "Комментарий для кандидата",
  },
  members: {
    subtitle: "Действующие члены Союза писателей.",
    search: "Поиск по ФИО, псевдониму или номеру билета",
    clearSearch: "Очистить поиск",
    notFound: "Никого не нашли. Измените запрос.",
    columns: { name: "ФИО", region: "Регион", cardNo: "Билет", joined: "В Союзе с", status: "Статус" },
  },
  works: {
    subtitle: "Произведения из портфолио писателей, ожидающие подтверждения авторства.",
    columns: { title: "Произведение", year: "Год", isbn: "ISBN", author: "Автор", added: "Добавлено", actions: "Решение" },
    rejectTitle: "Отклонить произведение",
    rejectMessage: "«{{title}}» не попадёт в публичную карточку писателя.",
  },
  authors: {
    sections: { name: "ФИО", membership: "Членство" },
    title: "Кабинет автора",
    hint: "Человек попадёт в реестр членов сразу. Вход появится, когда он откроет ссылку.",
    lastName: "Фамилия",
    firstName: "Имя",
    patronymic: "Отчество",
    pseudonym: "Псевдоним",
    region: "Регион",
    authorType: "Тип автора",
    cardNo: "Номер билета",
    joinedYear: "Год вступления",
    submit: "Создать кабинет",
    linkLabel: "Ссылка для автора",
    linkHint: "Передайте её человеку. Ссылка действует 30 дней и привязывает кабинет к его входу в НБР.",
    copy: "Скопировать",
    copied: "Ссылка скопирована",
  },
  claim: {
    title: "Кабинет автора",
    hint: "Привязать подготовленный профиль к вашему входу.",
    submit: "Привязать",
    missing: "В ссылке нет кода приглашения.",
    done: "Кабинет привязан.",
  },
}
